<template>
  <v-container class="py-10" id="herausforderungenUebersicht">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <div class="subtitle" style="color:#9d0c4a">
          Digitaler Reifegrad
        </div>
        <h2>Rolle der Anspruchsgruppen</h2>
        <p>
          Der positive Zusammenhang zwischen der digitalen Reife und dem Zugang
          zu Ressourcen wird beeinflusst von dem Grad der
          Anspruchsgruppenorientierung einer Organisation. Das bedeutet, dass
          Organisationen, die nach einer höheren digitalen Reife streben,
          gleichermaßen Wert auf einen interaktiven Austausch mit ihrem Umfeld
          legen sollten. Dadurch wird der positive Effekt im Sinne einer
          Verbesserung des Ressourcenzugangs ermöglicht bzw. verstärkt.
        </p>

        <v-btn
          rounded
          depressed
          color="accent"
          class="ma-2"
          min-width="65%"
          href="https://www.hausdesstiftens.org/wp-content/uploads/Digital-Report-2020-Final.pdf"
          target="blank"
        >
          Zur Studie
        </v-btn>

        <v-btn
          text
          rounded
          depressed
          color="accent"
          class="ma-2"
          min-width="65%"
          v-bind:class="{ active: showStakeholder }"
          v-on:click="showStakeholder = !showStakeholder"
        >
          <span v-if="!showStakeholder"
            ><v-icon>mdi-chevron-down</v-icon>Mehr erfahren</span
          >
          <span v-if="showStakeholder"
            ><v-icon>mdi-chevron-up</v-icon>Einklappen</span
          >
        </v-btn>
      </v-col>
      <v-col cols="12" lg="6">
        <img src="/images/Abbildung-50.svg" />
      </v-col>
    </v-row>
    <v-container v-if="showStakeholder">
      <p>
        Die Ergebnisse der zuvor beschriebenen Analysen zum digitalen Reifegrad
        deuten klar darauf hin, dass sowohl die genannten organisatorischen
        Charakteristika und Fähigkeiten als auch der Zugang zu den Ressourcen in
        Zusammenhang mit dem digitalen Reifegrad einer Organisation stehen. Aber
        gibt es Bedingungen, unter denen der Zusammenhang zwischen dem digitalen
        Reifegrad und dem Ressourcenzugang verändert wird? Hierzu haben wir
        erneut die drei Organisationsfähigkeiten “evidenzbasierte Strategie”,
        “Innovationskraft” und “Anspruchsgruppenorientierung” herangezogen und
        getestet, ob sie den Zusammenhang zwischen dem digitalen Reifegrad und
        dem Ressourcenzugang beeinflussen bzw. einen größeren Vorteil im Sinne
        eines erleichterten Ressourcenzugangs aus ihrer digitalen Reife
        ermöglichen.
      </p>
      <p>
        Interessanterweise lässt sich aus allen drei Fähigkeiten nur eine
        identifizieren, die den Zusammenhang zwischen digitaler Reife und dem
        Ressourcenzugang verändert - und zwar die Anspruchsgruppenorientierung.
        Dieser Faktor beeinflusst den Zusammenhang allerdings sehr robust und
        für alle gemessenen Ressourcenarten, unabhängig von der
        Finanzierungsform. Abbildung 50 veranschaulicht die Ergebnisse. Demnach
        wird der positive Zusammenhang zwischen der digitalen Reife und der Zahl
        der Spender, der Summe der Spenden, der Anzahl an Mitgliedern, dem
        Umsatz sowie dem Gewinn, erst ab einem bestimmten Niveau der
        Anspruchsgruppenorientierung überhaupt sichtbar und wird stärker, je
        intensiver die Organisation mit ihrem Umfeld im Dialog steht. Das
        bedeutet, dass Organisationen, die einen hohen digitalen Reifegrad
        erreicht haben, nicht per se einen besseren Zugang zu Ressourcen haben.
        Ob sie diese positiven Effekte realisieren können, hängt auch davon ab,
        ob sie einen intensiven Kontakt mit ihren Anspruchsgruppen pflegen oder
        nicht. Für die wenig anspruchsgruppenorientierten Organisationen finden
        wir somit keinen positiven Effekt des digitalen Reifegrades auf den
        Ressourcenzugang.
      </p>
      <p>
        Was bedeuten diese Ergebnisse für den Prozess der Digitalisierung in
        NPOs? Es reicht offensichtlich nicht nur aus, neue Technologien zu
        nutzen. Um tatsächlich einen Nutzen aus der Digitalisierung zu schöpfen,
        müssen NPOs auch die Einstellungen und Bedürfnisse ihrer vielfältigen
        Anspruchsgruppen verstehen. Diese bilden das Umfeld, in dem sich eine
        Organisation bewegt, und können der Organisation ihre Unterstützung
        geben oder entziehen. Insbesondere die mit
        <a
          href="https://www.hausdesstiftens.org/wp-content/uploads/Digital-Report-2020-Final.pdf#page=66"
          target="blank"
          >Premium Cola</a
        >
        sowie dem
        <a
          href="https://www.hausdesstiftens.org/wp-content/uploads/Digital-Report-2020-Final.pdf#page=66"
          target="blank"
          >TC Freisenbruch 1902 e.V.</a
        >
        geführten Interviews geben einen Eindruck davon, welche Chancen sich im
        Kontext der Digitalisierung offenbaren, wenn sich interne und externe
        Anspruchsgruppen regelmäßig austauschen und sie in Entscheidungsprozesse
        einbezogen werden. Die verschiedenen Social Media-Kanäle,
        Online-Plattformen, Befragungs- und Crowdfunding-Tools, die NPOs dabei
        zur Verfügung stehen, revolutionieren die Möglichkeiten der Interaktion
        und Integration.
      </p>
      <p>
        Weitere Informationen, was anspruchsgruppenorientierte NPOs ausmacht und
        wie sie mit ihren Anspruchsgruppen in Kontakt treten können, sind hier
        in unserer
        <a
          href="https://www.hausdesstiftens.org/wp-content/uploads/Digital-Report-2020-Final.pdf#page=64"
          target="blank"
        >
          Studie
        </a>
        zu finden.
      </p>
      <v-btn
        text
        rounded
        depressed
        color="accent"
        class="ma-2 d-block"
        v-on:click="showStakeholder = false"
        ><v-icon>mdi-chevron-up</v-icon>Einklappen</v-btn
      >
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "Stakeholder",
  data: () => ({
    showStakeholder: false
  }),
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text: "Digitalisierung als Herausforderung"
        },
        xAxis: {
          categories: [
            "Kirchen/religiöse Vereinigungen",
            "Soziale Dienste",
            "Bürger-/Verbraucherinteressen",
            "Bildung/Erziehung",
            "Umwelt-/Naturschutz",
            "Kultur/Medien",
            "Freizeit/Geselligkeit",
            "Andere",
            "Gesundheitswesen",
            "Gemeinschaftliche Versorgungsaufgaben",
            "Sport",
            "Wirtschafts-/Berufsverbände",
            "Internationale Solidarität",
            "Wissenschaft/Forschung",
            "Bevölkerungs-/Katastrophenschutz"
          ],
          labels: {
            align: "left",
            reserveSpace: true,
            style: {
              fontSize: "12"
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        legend: {
          enabled: true,
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: "percent",
            events: {
              legendItemClick: function() {
                return false;
              }
            }
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:12px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        //colors: ["#9d0c4a", "#ad4594", "#e353aa"],
        series: [
          {
            name: "Oberes Drittel",
            data: [
              27.64045,
              28.45118,
              30.30303,
              31.98146,
              32.23684,
              32.95455,
              33.33333,
              33.72781,
              34.10853,
              34.78261,
              36.57548,
              42.85714,
              43.90244,
              44.31818,
              45.11628
            ]
          },
          {
            name: "Mittleres Drittel",
            data: [
              35.73034,
              35.01684,
              36.36364,
              32.79258,
              34.86842,
              34.09091,
              40.27778,
              29.98028,
              31.00775,
              30.43478,
              35.86626,
              21.42857,
              23.17073,
              32.95455,
              28.37209
            ]
          },
          {
            name: "Unteres Drittel",
            data: [
              36.62921,
              36.53199,
              33.33333,
              35.22596,
              32.89474,
              32.95455,
              26.38889,
              36.29191,
              34.88372,
              34.78261,
              27.55826,
              35.71429,
              32.92683,
              22.72727,
              26.51163
            ]
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Copyright 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>
